import store from '@/store'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

export function checkPermissions (permission: string) {
    const permissions = store.state.UsersStore.userPermissions
    return !!permissions.find((p: { permissionName: string }) => p.permissionName === permission)
}

function handlePermissionsChange (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    if (Array.isArray(binding.value)) {
        binding.value.forEach(permission => {
            if (!checkPermissions(permission)) {
                if (vnode.elm?.parentElement) vnode.elm.parentElement.removeChild(vnode.elm)
            }
        })
    } else {
        if (!checkPermissions(binding.value)) {
            if (vnode.elm?.parentElement) {
                vnode.elm.parentElement.removeChild(vnode.elm)
            } else {
                el.style.display = 'none'
            }
        }
    }
}

const PermissionDirective = {
    bind: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) => {
        if (!binding.value) return

        handlePermissionsChange(el, binding, vnode)

        store.watch(state => state.UsersStore.userPermissions, () => {
            handlePermissionsChange(el, binding, vnode)
        })
    }
}

export { PermissionDirective }
